import { SavePartyMutation37kzgcr2r74ko as SavePartyMutation } from './schema/SavePartyMutation.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Accepted_instance387j2kbgg1xpz as Accepted_instance } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/CommandResult.mjs';
import { Dispatcher396y2mcz9r128 as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SavePartyCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_instanceldqbxvjihuns as Companion_instance } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { Companion_instanceuedomgwof6ax as Companion_instance_0 } from '../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/party/PairingRule.mjs';
import { SavePartyInput3ikp23en56cie as SavePartyInput } from './schema/type/SavePartyInput.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *perform(command, $completion) {
  yield* this.execute_csffyb_k$(new (SavePartyMutation())(savePartyInput(command.party_1)), $completion);
  return Accepted_instance;
}
var SdkSavePartyCommandDispatcherClass;
function SdkSavePartyCommandDispatcher() {
  if (SdkSavePartyCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkSavePartyCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkSavePartyCommandDispatcherClass = $;
  }
  return SdkSavePartyCommandDispatcherClass;
}
function savePartyInput(_this__u8e3s4) {
  return new (SavePartyInput())(_this__u8e3s4.id_1, Companion_instance.presentIfNotNull_z0sdzu_k$(_this__u8e3s4.name_1), Companion_instance.presentIfNotNull_z0sdzu_k$(_this__u8e3s4.email_1), Companion_instance.presentIfNotNull_z0sdzu_k$(Companion_instance_0.toValue_o5h68i_k$(_this__u8e3s4.pairingRule_1)), Companion_instance.presentIfNotNull_z0sdzu_k$(_this__u8e3s4.badgesEnabled_1), Companion_instance.presentIfNotNull_z0sdzu_k$(_this__u8e3s4.defaultBadgeName_1), Companion_instance.presentIfNotNull_z0sdzu_k$(_this__u8e3s4.alternateBadgeName_1), Companion_instance.presentIfNotNull_z0sdzu_k$(_this__u8e3s4.callSignsEnabled_1), Companion_instance.presentIfNotNull_z0sdzu_k$(_this__u8e3s4.animationEnabled_1), Companion_instance.presentIfNotNull_z0sdzu_k$(_this__u8e3s4.animationSpeed_1));
}
//region block: exports
export {
  SdkSavePartyCommandDispatcher as SdkSavePartyCommandDispatcher1x5cidvmu3vb0,
  perform as perform34ityj9uxq33g,
};
//endregion

//# sourceMappingURL=SdkSavePartyCommandDispatcher.mjs.map
